import {
    Autoformat,
    BlockQuote,
    Bold,
    CKBox,
    CKFinder,
    CKFinderUploadAdapter,
    ClassicEditor,
    CloudServices,
    EasyImage,
    EditorConfig,
    Essentials,
    Heading,
    Image,
    ImageCaption,
    ImageStyle,
    ImageToolbar,
    ImageUpload,
    Indent,
    Italic,
    Link,
    List,
    MediaEmbed,
    Paragraph,
    PasteFromOffice,
    PictureEditing,
    Table,
    TableToolbar,
    TextTransformation,
} from 'ckeditor5';

/**
 * The editor and configuration that replace @ckeditor/ckeditor5-build-classic.
 *
 * CKEditor retired the prebuilt bundles: build-classic stopped at 44.3.0, which still carries the
 * clipboard and html-support XSS advisories and pulls a lodash-es with a code-injection advisory.
 * The maintained distribution is the single `ckeditor5` package, but it ships no default plugin
 * set, so the four editors in this app -- which passed no configuration at all and relied entirely
 * on the build's defaults -- need that set written down.
 *
 * The plugins and toolbar below are the classic build's own defaults, read out of its bundle, so
 * the editors keep the buttons they had.
 */
export const CKEDITOR_PLUGINS = [
    Essentials,
    CKFinderUploadAdapter,
    Autoformat,
    Bold,
    Italic,
    BlockQuote,
    CKBox,
    CKFinder,
    CloudServices,
    EasyImage,
    Heading,
    Image,
    ImageCaption,
    ImageStyle,
    ImageToolbar,
    ImageUpload,
    Indent,
    Link,
    List,
    MediaEmbed,
    Paragraph,
    PasteFromOffice,
    PictureEditing,
    Table,
    TableToolbar,
    TextTransformation,
];

export const CKEDITOR_CONFIG: EditorConfig = {
    // Required since CKEditor 5 v44: without it the editor refuses to start. 'GPL' is the value for
    // open-source use under the GPL, which is how this app uses it -- no commercial licence, and no
    // cloud services are configured.
    licenseKey: 'GPL',
    plugins: CKEDITOR_PLUGINS,
    toolbar: {
        items: [
            'undo',
            'redo',
            '|',
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'link',
            'uploadImage',
            'insertTable',
            'blockQuote',
            'mediaEmbed',
            '|',
            'bulletedList',
            'numberedList',
            'outdent',
            'indent',
        ],
    },
};

export { ClassicEditor };
